<template lang="pug">
  sui-container
    transition(name="fade")
      sui-dimmer(
        inverted,
        active,
        v-if="loading")
        sui-loader Loading...

    sui-segment(
      v-if="!loading",
      text-align="center",
      vertical)
      sui-grid
        sui-grid-row(:style="`background-color: ${team.colors.primary.color}`")
          sui-grid-column
            sui-image(
              size="medium",
              :src="team.logo.mainName.svg",
              centered)

        sui-grid-row(:style="`background-color: ${team.colors.secondary.color}`")

    sui-segment(
      vertical,
      v-if="!loading")
      sui-header(size="large") Players
      sui-card-group(
        :items-per-row="6",
        stackable)
        player-card(
          v-for="player in players",
          :key="player.playerId",
          :player="player")
</template>

<script>
import PlayerCard from '@/components/player/PlayerCard.vue';

export default {
  name: 'Team',
  components: {
    PlayerCard,
  },
  computed: {
    teamId() {
      return Number(this.$route.params.teamId) || 0;
    },
    loading() {
      return this.$store.state.loading;
    },
    team() {
      return this.$store.state.teams.find(x => x.teamId === this.teamId);
    },
    players() {
      return this.$store.state.players.filter(x => x.teamId === this.teamId);
    },
  },
};
</script>
